"use client"

import mixpanel from "mixpanel-browser"
import { useEffect } from "react"

export function Tracked() {
    useEffect(() => {
        mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN ?? "c56e94e481c20c32604ce76851254a6d", {
            track_pageview: true,
            persistence: "localStorage",
        })
    }, [])

    return <></>
}
